import { override } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DOMPurify from 'dompurify';

app.initializers.add('konsensus-flarum-render-html', function() {
  console.log('[Render HTML] Extension initialized - NUCLEAR OPTION');

  // Nuclear option: completely replace the view method
  override(CommentPost.prototype, 'view', function(original) {
    // Get the original rendered post
    const vdom = original();

    console.log('[Render HTML] View called, vdom:', vdom);

    const post = this.attrs.post;
    if (!post || !post.data || !post.data.attributes) {
      return vdom;
    }

    let rawContent = post.data.attributes.content;
    if (!rawContent) {
      return vdom;
    }

    console.log('[Render HTML] Processing HTML content');

    // Decode HTML entities
    const textarea = document.createElement('textarea');
    textarea.innerHTML = rawContent;
    const decodedContent = textarea.value;

    // Sanitize
    const cleanContent = DOMPurify.sanitize(decodedContent, {
      ALLOWED_TAGS: [
        'div', 'span', 'p', 'br', 'strong', 'em', 'u', 's', 'a',
        'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'blockquote', 'code', 'pre', 'img', 'table', 'thead',
        'tbody', 'tr', 'th', 'td', 'b', 'i', 'hr', 'del', 'ins'
      ],
      ALLOWED_ATTR: [
        'href', 'src', 'alt', 'title', 'class', 'id', 'style',
        'target', 'rel', 'width', 'height'
      ],
      ALLOW_DATA_ATTR: false
    });

    console.log('[Render HTML] Clean content:', cleanContent);

    // Recursively find and replace the Post-body content
    function findAndReplaceContent(node) {
      if (!node) return false;

      if (node.attrs && node.attrs.className) {
        const className = node.attrs.className;
        // Check if this is the Post-body container
        if (typeof className === 'string' && className.includes('Post-body')) {
          console.log('[Render HTML] Found Post-body, replacing content');
          // Replace the children with our trusted HTML
          node.children = [m.trust(cleanContent)];
          return true;
        }
      }

      // Recursively check children
      if (node.children && Array.isArray(node.children)) {
        for (let child of node.children) {
          if (findAndReplaceContent(child)) {
            return true;
          }
        }
      }

      return false;
    }

    findAndReplaceContent(vdom);

    return vdom;
  });
});
